import axios from "@/utils/request";
//监考证查询
export function inventory(data) {
  return axios({
    url: "/public_query/invigilation_cert",
    method: "post",
    data,
  });
}
